// Code generated by Prismic. DO NOT EDIT.

import CallToAction from "./CallToAction";
import CaseStudies from "./CaseStudies";
import ContactFormSection from "./ContactFormSection";
import Faqs from "./Faqs";
import Hero from "./Hero";
import FeatureTickerList from "./FeatureTickerList";
import List from "./List";
import LocationMapCallout from "./LocationMapCallout";
import MediaSection from "./MediaSection";
import Megamenu from "./Megamenu";
import Reviews from "./Reviews";
import Section from "./Section";
import SoleDeconstruct from "./SoleDeconstruct";
import TeamCarousel from "./TeamCarousel";
import Testimonial from "./Testimonial";
import Testimonials from "./Testimonials";
import Timeline from "./Timeline";
import VerticalStepsWithImages from "./VerticalStepsWithImages";

export const components = {
	call_to_action: CallToAction,
	case_studies: CaseStudies,
	contact_form_section: ContactFormSection,
	faqs: Faqs,
	hero: Hero,
	icon_nav_list: FeatureTickerList,
	list: List,
	location_map_callout: LocationMapCallout,
	media_section: MediaSection,
	megamenu: Megamenu,
	reviews: Reviews,
	section: Section,
	sole_deconstruct: SoleDeconstruct,
	team_carousel: TeamCarousel,
	testimonial: Testimonial,
	testimonials: Testimonials,
	timeline: Timeline,
	vertical_steps_with_images: VerticalStepsWithImages
};